import callAPiBase from './base';

const tollApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/tollList',
      method: 'GET',
      useToken: true,
      title: 'Toll - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tollCreate',
      method: 'POST',
      useToken: true,
      title: 'Toll - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/tollUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Toll - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/tollDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Toll - Delete',
      params,
    }),
};

export { tollApi };
export default tollApi;
